import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import MineProjectDetails from "./MineProjectDetails";
import MineProjectAllProposals from "./MineProjectAllProposals";
import MineProjectShortlisted from "./MineProjectShortlisted";
import { useNavigate, useParams } from "react-router-dom";
import { getPostsById, getPostsCancelById } from "../../../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";
import { decodeHtml } from "../../../../../../../assests/extention/commonfunction";

export default function MineProjectDetailsTabs() {
  const { urlstate, setMyorderRecentprojectroute } = useRouteBaseStateContext();
  const { id } = useParams();
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  const [activeTab, setActiveTab] = useState("Projectdetails");

  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const navigate = useNavigate()
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (urlstate?.myorderrecentprojectroute) {
      setActiveTab(urlstate?.myorderrecentprojectroute || "Projectdetails");
    } else {
      setActiveTab("Projectdetails");
    }
  }, [urlstate, urlstate?.myorderrecentprojectroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyorderRecentprojectroute(tab);
  };

  const proposalcount = posts?.proposal || [];
  const wishlistproposalcount =
    posts?.proposal?.filter((item) => item.wishlist == 1) || [];


  const directpayment = (item) => {
    const state = {
      id: posts?.id,
      milestone_id: item?.milestones[0]?.id,
      milestone_amount: item?.milestones[0]?.amount,
      type: 1,
      type_of_post: "project",
      post_id: posts?.id,
      post_price: item?.milestones[0]?.amount,
      proposal_id: item?.id,
    };
    navigate(`/${lan}/account/paymentmethodpage`, { state: { orderdetails: state } });
  }


  const cancelpost = () => {
    const data = {
      "post_id": posts?.id,
      "type": "1",
      "status": "4"
    }
    dispatch(getPostsCancelById(data))
  }

  return (
    <div className="project-section">
      <h4>{decodeHtml(posts?.title)}</h4>
      <div className="">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Projectdetails" ? "active" : ""}`}
              onClick={() => handleTabClick("Projectdetails")}
            >
              Project Details
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Allproposals" ? "active" : ""}`}
              onClick={() => handleTabClick("Allproposals")}
            >
              All Proposals ({proposalcount.length})
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Shortlisted" ? "active" : ""}`}
              onClick={() => handleTabClick("Shortlisted")}
            >
              Shortlisted ({wishlistproposalcount.length})
            </a>
          </li>
        </ul>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "Projectdetails" ? "active" : ""}`}
            id="Projectdetails"
          >
            <MineProjectDetails
              posts={posts}
              proposalcount={proposalcount.length}
              cancelpost={cancelpost}
            />
          </div>
          <div
            className={`tab-pane ${activeTab == "Allproposals" ? "active" : ""}`}
            id="Allproposals"
          >
            <MineProjectAllProposals posts={posts} directpayment={directpayment} />
          </div>
          <div
            className={`tab-pane ${activeTab == "Shortlisted" ? "active" : ""}`}
            id="Shortlisted"
          >
            <MineProjectShortlisted posts={posts} />
          </div>
        </div>
      </div>
    </div>
  );
}
